// Route.buildings / route.grades are comma-separated (e.g. "B-03,B-04,B-05,B-06").
// A route with no buildings or grades listed is treated as unrestricted.

export function splitCsv(value) {
  return String(value || "")
    .split(",")
    .map((v) => v.trim())
    .filter((v) => v.length > 0);
}

// Student.class is usually already "B-03". Also try the bare grade and
// branch-prefixed form so "03" / branch "B" still matches "B-03".
export function studentGradeTokens(student) {
  const grade = String((student && student.class) || "").trim();
  const branch = String((student && student.branch) || "").trim();
  const tokens = [];
  if (grade) {
    tokens.push(grade);
    const dash = grade.lastIndexOf("-");
    if (dash > 0) {
      tokens.push(grade.substring(dash + 1));
    }
  }
  if (
    branch &&
    grade &&
    !grade.toUpperCase().startsWith(branch.toUpperCase() + "-")
  ) {
    tokens.push(branch + "-" + grade);
  }
  return tokens;
}

export function routeMatchesCsv(routeValue, wantedValues) {
  const wanted = (wantedValues || [])
    .map((v) => String(v || "").trim().toUpperCase())
    .filter(Boolean);
  if (!wanted.length) return true;
  const routeParts = splitCsv(routeValue).map((v) => v.toUpperCase());
  if (!routeParts.length) return true;
  return wanted.some((w) => routeParts.includes(w));
}

export function routeMatchesStudent(route, student) {
  if (!route || !student) return true;
  const building = student.building;
  return (
    routeMatchesCsv(route.buildings, building ? [building] : []) &&
    routeMatchesCsv(route.grades, studentGradeTokens(student))
  );
}

// requireAllGrades=true: route must work for every student (shared bus).
// requireAllGrades=false: route must work for at least one student.
export function routeMatchesStudents(route, students, requireAllGrades) {
  const list = (students || []).filter(Boolean);
  if (!list.length) return true;
  if (requireAllGrades) {
    return list.every((s) => routeMatchesStudent(route, s));
  }
  return list.some((s) => routeMatchesStudent(route, s));
}

// A route with no driver is not running. driver_Bus_ID alone still counts as assigned.
export function routeHasDriver(route) {
  if (!route) return false;
  if (String(route.driver || route.Driver || "").trim()) return true;
  const id =
    route.driver_Bus_ID != null ? route.driver_Bus_ID : route.Driver_Bus_ID;
  return id != null && String(id).trim() !== "";
}

export function ensureRouteIncluded(routes, selected) {
  if (!selected || !routeHasDriver(selected)) return routes || [];
  const id = selected.id != null ? selected.id : selected.ID;
  if (id == null) return routes || [];
  const list = routes || [];
  if (list.some((r) => (r.id != null ? r.id : r.ID) == id)) {
    return list;
  }
  return list.concat([selected]);
}
